import "../css/Reviews.css"
import StyledRating from '@mui/material/Rating'
import { LinearProgress } from "@mui/material";
import { Review } from "./Review";
import {
    activeReviews,
    averageRatingForGroup,
    ratingValue,
    ratingValuesForGroup,
} from '../utilities/fieldData';

export const Reviews = ({field}) => {
    const reviews = activeReviews(field);

    if (reviews.length === 0) {
        return (
            <div className="reviews">
                <p>No reviews have been submitted for this field.</p>
            </div>
        );
    }

    return (
        <>
            <div className="reviews">
                <div className="review-groups">
                    <ReviewGroup reviews={reviews} title="Overall" groupKey="overall" />
                    <ReviewGroup reviews={reviews} title="Infield" groupKey="infield" />
                    <ReviewGroup reviews={reviews} title="Outfield" groupKey="outfield" />
                    <ReviewGroup reviews={reviews} title="Surrounding Area" groupKey="surrounding" />
                </div>
                {reviews.map((review, index) => <Review key={`${review.reviewer_email}-${review.date}-${index}`} review={review} />)}
            </div>
        </>
    );
}

const totalReviewsForStarCount = (reviews, starCount, groupKey) => {
    let total = 0;

    for (let i = 0; i < reviews.length; i++) {
        if (ratingValue(reviews[i][groupKey]) === starCount) {
            total += 1;
        }
    }

    return total;
}

const ReviewBreakdown = ({reviews, groupKey}) => {
    const ratedCount = ratingValuesForGroup(reviews, groupKey).length;

    return (
        <div className="review-breakdown">
            <>
            {[5,4,3,2,1].map(v =>
                <div key={v} className="review-breakdown-row">
                    <p className="star-count">{v} stars</p>
                    <LinearProgress className="progress" variant="determinate" value={ratedCount > 0 ? totalReviewsForStarCount(reviews, v, groupKey) / ratedCount * 100.0 : 0} color="secondary" />
                    <p>{totalReviewsForStarCount(reviews, v, groupKey)}</p>
                </div>
            )}
            </>
        </div>
    );
}

const ReviewGroup = ({reviews, title, groupKey}) => {
    const ratingForGroup = averageRatingForGroup(reviews, groupKey);

    if (ratingForGroup === undefined) {
        return null;
    }

    return (
            <div className="review-group">
                <p className="review-group-title">{title}</p>
                <StyledRating
                    className="review-group-overall-rating"
                    name="field-rating"
                    defaultValue={ratingForGroup}
                    value={ratingForGroup}
                    precision={0.5}
                    icon={<img alt="Rated" src="/rating-gold.svg" />}
                    emptyIcon={<img alt="Not rated" src="/rating-off.svg" />}
                    readOnly
                />
                <ReviewBreakdown reviews={reviews} groupKey={groupKey} />
            </div>
    )
}
